import request from '@/utils/request'

// 查询字典数据列表
export function listData(params) {
  return request({
    url: '/system/dictdata/pagelist',
    method: 'post',
    data: params
  })
}

// 查询字典数据详细
export function getData(dictCode) {
  return request({
    url: '/system/dictdata/detail/' + dictCode,
    method: 'get'
  })
}

// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
  return request({
    url: '/system/dictdata/list/' + dictType,
    method: 'get'
  })
}

// 新增字典数据
export function addData(params) {
  return request({
    url: '/system/dictdata/add',
    method: 'post',
    data: params
  })
}

// 修改字典数据
export function updateData(params) {
  return request({
    url: '/system/dictdata/edit',
    method: 'post',
    data: params
  })
}

// 删除字典数据
export function delData(dictCode) {
  return request({
    url: '/system/dictdata/remove/' + dictCode,
    method: 'get'
  })
}
